import { render, staticRenderFns } from "./createComponent.vue?vue&type=template&id=1f72c791&scoped=true&"
import script from "./createComponent.vue?vue&type=script&lang=js&"
export * from "./createComponent.vue?vue&type=script&lang=js&"
import style0 from "./createComponent.vue?vue&type=style&index=0&id=1f72c791&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f72c791",
  null
  
)

export default component.exports